/* MMM Rangoli PDP — design picker, gallery, quantity, sticky bar.
   Add-to-cart itself is handled by the theme's native <product-form> (cart drawer included). */
(function () {
  'use strict';

  var BLANK_GIF = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var whole = String(Math.round(cents / 100));
    var comma = value.replace('.', ',');
    return (format || '£{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return whole;
      if (key === 'amount_with_comma_separator') return comma;
      if (key === 'amount_no_decimals_with_comma_separator') return whole;
      return value;
    });
  }

  function init(root) {
    if (!root || root.__rgReady) return;
    root.__rgReady = true;

    var form = root.querySelector('#mmm-rg-form');
    if (!form) return;

    var tiles = [].slice.call(root.querySelectorAll('[data-rg-tile]'));
    var idInput = root.querySelector('[data-rg-variant-id]');
    var status = root.querySelector('[data-rg-status]');
    var live = root.querySelector('[data-rg-live]');
    var priceEl = root.querySelector('[data-rg-price]');
    var main = root.querySelector('[data-rg-main]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-rg-thumb]'));
    var designThumb = root.querySelector('[data-rg-thumb][data-kind="design"]');
    var atc = root.querySelector('[data-rg-atc]');
    var atcText = root.querySelector('[data-rg-atc-text]');
    var qtyInput = root.querySelector('[data-rg-qty-input]');
    var sticky = root.querySelector('[data-rg-sticky]');
    var stickySub = root.querySelector('[data-rg-sticky-sub]');
    var stickyBtn = root.querySelector('[data-rg-sticky-btn]');
    var picker = root.querySelector('[data-rg-picker]');
    var added = root.querySelector('[data-rg-added]');
    var addedName = root.querySelector('[data-rg-added-name]');
    var addAnother = root.querySelector('[data-rg-add-another]');
    var money = root.getAttribute('data-rg-money');
    var reveal = parseInt(root.getAttribute('data-rg-reveal'), 10) || 700;
    var emptyText = status ? status.getAttribute('data-empty') : 'Please choose your design';
    var firstPrice = tiles.length ? parseInt(tiles[0].getAttribute('data-price'), 10) : 0;
    var current = null;

    function qty() {
      var q = parseInt(qtyInput && qtyInput.value, 10);
      if (!q || q < 1) q = 1;
      return Math.min(q, 20);
    }

    function setMain(src, alt) {
      if (!main || !src || main.tagName !== 'IMG') return;
      if (main.getAttribute('src') === src) return;
      main.classList.add('is-swapping');
      var pre = new Image();
      var done = function () {
        main.setAttribute('src', src);
        main.removeAttribute('srcset');
        if (alt) main.setAttribute('alt', alt);
        main.classList.remove('is-swapping');
      };
      pre.onload = done;
      pre.onerror = done;
      pre.src = src;
    }

    function setActiveThumb(el) {
      thumbs.forEach(function (t) {
        var on = t === el;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function updateButtons() {
      var q = qty();
      var label;
      var canBuy = false;
      if (!current) {
        label = emptyText;
      } else if (current.getAttribute('data-available') !== 'true') {
        label = 'Sold out';
      } else {
        canBuy = true;
        label = 'Add to bag — ' + formatMoney(parseInt(current.getAttribute('data-price'), 10) * q, money);
      }
      if (atcText) atcText.textContent = label;
      if (atc) {
        if (canBuy) atc.removeAttribute('disabled');
        else atc.setAttribute('disabled', 'disabled');
      }
      if (stickyBtn) stickyBtn.textContent = canBuy ? 'Add to Bag' : (current ? 'Sold out' : 'Choose a design');
      if (stickySub) {
        stickySub.textContent = current
          ? current.getAttribute('data-name') + ' • ' + current.getAttribute('data-price-html')
          : 'No design selected • ' + formatMoney(firstPrice, money);
      }
    }

    function updateUrl(id) {
      try {
        var url = new URL(window.location.href);
        if (id) url.searchParams.set('variant', id);
        else url.searchParams.delete('variant');
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* non-critical */ }
    }

    function select(tile, opts) {
      opts = opts || {};
      current = tile;
      tiles.forEach(function (t) {
        var on = t === tile;
        t.classList.toggle('is-selected', on);
        var r = t.querySelector('input');
        if (r) r.checked = on;
      });

      if (tile) {
        var id = tile.getAttribute('data-variant-id');
        var name = tile.getAttribute('data-name');
        if (idInput) idInput.value = id;
        if (status) status.textContent = 'Selected: ' + name;
        if (priceEl) priceEl.textContent = tile.getAttribute('data-price-html');
        if (live && !opts.silent) live.textContent = 'Selected design: ' + name;
        updateUrl(id);

        var src = tile.getAttribute('data-colour-src');
        var alt = tile.getAttribute('data-colour-alt');
        if (designThumb && src) {
          var img = designThumb.querySelector('img');
          designThumb.hidden = false;
          designThumb.setAttribute('data-src', src);
          designThumb.setAttribute('data-alt', alt);
          designThumb.setAttribute('aria-label', name + ' design');
          if (img) img.setAttribute('src', src);
          setMain(src, alt);
          setActiveThumb(designThumb);
        }
        if (added && !opts.keepAdded) added.hidden = true;
      } else {
        if (idInput) idInput.value = '';
        if (status) status.textContent = emptyText;
        if (priceEl) priceEl.textContent = formatMoney(firstPrice, money);
        if (designThumb) {
          designThumb.hidden = true;
          var di = designThumb.querySelector('img');
          if (di) di.setAttribute('src', BLANK_GIF);
        }
        var kit = root.querySelector('[data-rg-thumb][data-kind="kit"]');
        if (kit) {
          setMain(kit.getAttribute('data-src'), kit.getAttribute('data-alt'));
          setActiveThumb(kit);
        }
        updateUrl(null);
      }
      updateButtons();
    }

    /* ---- design tiles ---- */
    tiles.forEach(function (tile) {
      var radio = tile.querySelector('input');
      if (!radio) return;
      radio.addEventListener('change', function () {
        if (radio.checked && !radio.disabled) select(tile);
      });
    });

    /* ---- gallery thumbs ---- */
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        setMain(t.getAttribute('data-src'), t.getAttribute('data-alt'));
        setActiveThumb(t);
      });
    });

    /* ---- quantity ---- */
    var minus = root.querySelector('[data-rg-qty-minus]');
    var plus = root.querySelector('[data-rg-qty-plus]');
    function setQty(n) {
      if (!qtyInput) return;
      qtyInput.value = Math.min(20, Math.max(1, n));
      updateButtons();
    }
    if (minus) minus.addEventListener('click', function () { setQty(qty() - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(qty() + 1); });
    if (qtyInput) {
      qtyInput.addEventListener('input', updateButtons);
      qtyInput.addEventListener('change', function () { setQty(qty()); });
    }

    /* ---- back link ---- */
    var back = root.querySelector('[data-rg-back]');
    if (back) {
      back.addEventListener('click', function (e) {
        try {
          if (document.referrer && new URL(document.referrer).origin === window.location.origin && window.history.length > 1) {
            e.preventDefault();
            window.history.back();
          }
        } catch (err) { /* fall back to href */ }
      });
    }

    /* ---- sticky mobile bar ---- */
    function scrollToPicker() {
      if (!picker) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      picker.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      var first = picker.querySelector('input:not([disabled])');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduce ? 0 : 450);
    }

    if (sticky && stickyBtn) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var show = window.pageYOffset > reveal;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          stickyBtn.tabIndex = show ? 0 : -1;
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      stickyBtn.addEventListener('click', function () {
        if (!current || current.getAttribute('data-available') !== 'true') {
          scrollToPicker();
          return;
        }
        if (typeof form.requestSubmit === 'function' && atc) form.requestSubmit(atc);
        else if (atc) atc.click();
      });
    }

    /* ---- after add to bag ---- */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (!evt || evt.source !== 'product-form' || !added) return;
        if (addedName && current) addedName.textContent = current.getAttribute('data-name');
        added.hidden = false;
      });
    }
    if (addAnother) {
      addAnother.addEventListener('click', function () {
        added.hidden = true;
        select(null);
        scrollToPicker();
      });
    }

    /* ---- initial state (supports ?variant= via server-side preselect) ---- */
    var pre = tiles.filter(function (t) { return t.querySelector('input').checked; })[0] || null;
    select(pre, { silent: true });
  }

  function initAll() {
    [].slice.call(document.querySelectorAll('[data-rg]')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Theme editor: re-init when the section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-rg]') : null;
    if (el) init(el);
  });
})();
